import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { adminActions } from "../../../redux/actions";
import { Beat } from "../../../redux/reducers/spinner";
import {
  MDBContainer,
  MDBBtn,
  MDBModal,
  MDBModalBody,
  MDBModalHeader,
  MDBModalFooter,
} from "mdbreact";
import Location from "../../includes/Location";
import "react-phone-number-input/style.css";
import PhoneInput from "react-phone-number-input";

function CreateEmployee() {
  const dispatch = useDispatch();

  //This is to get company details
  const [myCompany, setMyCompany] = React.useState({});
  useEffect(() => {
    let isUnmount = false;

    const getMyCompany = async () => {
      let companyData = JSON.parse(await localStorage.getItem("myCompany"));
      if (!isUnmount) {
        companyData && setMyCompany(companyData);
        companyData &&
          setData((data) => ({
            ...data,
            user_city: companyData.company_city,
            user_state: companyData.company_state,
            user_country: companyData.company_country,
          }));
      }
    };
    getMyCompany();
    return () => {
      isUnmount = true;
    };
  }, []);

  // Get company id, to be used as input for creating employee
  let user = JSON.parse(localStorage.getItem("user"));
  let teamId = JSON.parse(localStorage.getItem("teamId"));
  const id = user?.data?.groups[teamId]?.company_id;

  // Modal actions
  const [open, setOpen] = React.useState(false);

  const handleClose = () => {
    setOpen(false);
  };

  //This is used to get the list of region data ie: country, city and states
  const [locationId, setLocationId] = React.useState({
    country_id: "",
    state_id: "",
    city_id: "",
  });
  const [locationList, setLocationList] = React.useState({
    countryList: [],
    stateList: [],
    cityList: [],
  });
  const toJson = (value) => JSON.stringify(value);
  const fromJson = (value) => JSON.parse(value);

  // Form actions
  const [submitted, setSubmitted] = useState(false);
  let [user_phone, setUserPhone] = useState("");
  const [data, setData] = useState({
    company_id: "",
    user_name: "",
    user_email: "",
    user_password: "",
    user_password_confirmation: "",
    // employee_name: "",
    // user_phone: "",
    user_job_title: "",
    user_address: "",
    user_city: "",
    user_state: "",
    user_country: "",
  });
  const {
    user_email,
    user_password,
    user_password_confirmation,
    user_name,
    user_job_title,
    user_address,
    user_city,
    user_state,
    user_country,
  } = data;
  const creating = useSelector((state) => state.admin.creating);
  user_phone = user_phone?.slice(1);
  // const loading = useSelector(state => state.data.loading);

  // Used to toggle the password visibility
  function toggleFunction(e) {
    var x = document.getElementById("password");
    if (x.type === "password") {
      x.type = "text";
    } else {
      x.type = "password";
    }

    // toggle the eye slash icon
    e.target.classList.toggle("i-Eye1");
  }
  function toggleFunction2(e) {
    var x = document.getElementById("password2");
    if (x.type === "password") {
      x.type = "text";
    } else {
      x.type = "password";
    }

    // toggle the eye slash icon
    e.target.classList.toggle("i-Eye1");
  }

  const handleChange = (event) => {
    const { name, value } = event.target;
    setData((data) => ({ ...data, [name]: value }));
  };

  function handleRegion(e) {
    const { name, value } = e.target;
    setData((data) => ({ ...data, [name]: fromJson(value).name }));
  }

  // Create employee and also set the action of employee
  const handleSubmit = (event) => {
    event.preventDefault();
    setSubmitted(true);

    if (
      user_email &&
      user_job_title &&
      user_address &&
      user_city &&
      user_state &&
      user_country
    ) {
      // dispatch action to create employee

      dispatch(
        adminActions.createEmployees(
          {
            ...data,
            // user_phone,
            company_id: id,
            user_name: data.user_name,
            user_phone: user_phone,
          },
          id,
          setOpen
        )
      );

      //  handleClose();
    }
  };

  return (
    <div>
      <MDBContainer>
        <MDBBtn color="primary" onClick={() => setOpen(true)}>
          Create Employee
        </MDBBtn>
        <MDBModal isOpen={open} toggle={handleClose}>
          <form name="form" onSubmit={handleSubmit}>
            <MDBModalHeader toggle={handleClose}>
              Add a new employee to your company
            </MDBModalHeader>
            <MDBModalBody>
              <div className="text-left row pt-4">
                <div
                  className={
                    "form-group col-md-6 mb-4" +
                    (submitted && user_name ? " has-error" : "")
                  }
                >
                  <label htmlFor="user_name">Employee name*</label>
                  <input
                    type="text"
                    className="form-control"
                    name="user_name"
                    onChange={handleChange}
                  />
                  {submitted && !user_name && (
                    <div className="help-block">Employee name is required</div>
                  )}
                </div>

                <div
                  className={
                    "form-group col-md-6 mb-4" +
                    (submitted && user_email ? " has-error" : "")
                  }
                >
                  <label htmlFor="user_email">Employee email*</label>
                  <input
                    type="email"
                    autoComplete="off"
                    className="form-control"
                    name="user_email"
                    onChange={handleChange}
                  />
                  {submitted && !user_email && (
                    <div className="help-block">Employee email is required</div>
                  )}
                </div>
                <div
                  className={
                    "form-group col-md-6 mb-4" +
                    (submitted && user_password ? " has-error" : "")
                  }
                >
                  <label htmlFor="user_password">Employee password*</label>
                  <br />
                  <small>Must have a minimum of 6 characters</small>
                  <input
                    type="password"
                    id="password"
                    autoComplete="off"
                    className="form-control"
                    name="user_password"
                    onChange={handleChange}
                  />
                  {submitted && !user_password && (
                    <div className="help-block">
                      Employee password is required
                    </div>
                  )}
                  <i
                    className="i-Eye-Visible toggleIcon"
                    onClick={toggleFunction}
                  ></i>
                </div>
                <div
                  className={
                    "form-group col-md-6 mb-4" +
                    (submitted && user_password_confirmation
                      ? " has-error"
                      : "")
                  }
                >
                  <label htmlFor="user_password_confirmation">
                    Employee password confirmation*
                  </label>
                  <br />
                  <small>Must have a minimum of 6 characters</small>
                  <input
                    type="password"
                    id="password2"
                    autoComplete="off"
                    className="form-control"
                    name="user_password_confirmation"
                    onChange={handleChange}
                  />
                  {submitted && !user_password_confirmation && (
                    <div className="help-block">
                      Employee password confirmation is required
                    </div>
                  )}
                  <i
                    className="i-Eye-Visible toggleIcon"
                    onClick={toggleFunction2}
                  ></i>
                </div>

                <div
                  className={
                    "form-group col-md-12 mb-4" +
                    (submitted && user_address ? " has-error" : "")
                  }
                >
                  <label htmlFor="user_address">Employee address*</label>
                  <input
                    type="text"
                    className="form-control"
                    name="user_address"
                    onChange={handleChange}
                  />
                  {submitted && !user_address && (
                    <div className="help-block">
                      Employee address is required.
                    </div>
                  )}
                </div>

                <div
                  className={
                    "form-group col-md-6 mb-4" +
                    (submitted && user_job_title ? " has-error" : "")
                  }
                >
                  <label htmlFor="user_job_title">
                    Employee job title*
                  </label>
                  <input
                    type="text"
                    name="user_job_title"
                    onChange={handleChange}
                    className={
                      "form-control" +
                      (submitted && !user_job_title ? " is-invalid" : "")
                    }
                  />
                  {submitted && !user_job_title && (
                    <div className="help-block">
                      Employee job title is required
                    </div>
                  )}
                </div>

                <div
                  className={
                    "form-group col-md-6 mb-4" +
                    (submitted && user_phone ? " has-error" : "")
                  }
                >
                  <label htmlFor="user_phone">Employee phone*</label>
                  <PhoneInput
                    defaultCountry="NG"
                    className="form-control"
                    value={user_phone}
                    onChange={setUserPhone}
                  />
                  {submitted && !user_phone && (
                    <div className="help-block">Employee phone is required</div>
                  )}
                </div>

                {/* Here, we utilize the location component to get the location data */}
                <Location
                  country_id={locationId.country_id}
                  state_id={locationId.state_id}
                  city_id={locationId.city_id}
                  countryList={(value) => {
                    setLocationList({ ...locationList, countryList: value });
                  }}
                  stateList={(value) => {
                    setLocationList({ ...locationList, stateList: value });
                  }}
                  cityList={(value) => {
                    setLocationList({ ...locationList, cityList: value });
                  }}
                  country_name={myCompany.company_country}
                  state_name={myCompany.company_state}
                  city_name={myCompany.company_city}
                />

                <div
                  className={
                    "form-group col-md-6 mb-4" +
                    (submitted && user_country ? " has-error" : "")
                  }
                >
                  <label htmlFor="user_country">Employee country*</label>
                  <select
                    name="user_country"
                    className="form-control"
                    onChange={(e) => {
                      setLocationId({
                        ...locationId,
                        country_id: fromJson(e.target.value).id,
                      });
                      handleRegion(e);
                    }}
                  >
                    {myCompany.company_country && (
                      <option>{myCompany.company_country}</option>
                    )}
                    {locationList.countryList &&
                      locationList.countryList.length > 0 &&
                      locationList.countryList.map((item, key) => {
                        return (
                          <option
                            key={key}
                            value={toJson({ name: item.name, id: item.id })}
                          >
                            {item.name}
                          </option>
                        );
                      })}
                  </select>
                  {submitted && !user_country && (
                    <div className="help-block">
                      Employee country is required
                    </div>
                  )}
                </div>

                <div
                  className={
                    "form-group col-md-6 mb-4" +
                    (submitted && user_state ? " has-error" : "")
                  }
                >
                  <label htmlFor="user_state">Employee state </label>
                  <select
                    name="user_state"
                    className="form-control"
                    onChange={(e) => {
                      setLocationId({
                        ...locationId,
                        state_id: fromJson(e.target.value).id,
                      });
                      handleRegion(e);
                    }}
                  >
                    {myCompany.company_state && (
                      <option>{myCompany.company_state}</option>
                    )}
                    {locationList.stateList &&
                      locationList.stateList.length > 0 &&
                      locationList.stateList.map((item, key) => {
                        return (
                          <option
                            key={key}
                            value={toJson({ name: item.name, id: item.id })}
                          >
                            {item.name}
                          </option>
                        );
                      })}
                  </select>
                  {submitted && !user_state && (
                    <div className="help-block">
                      Employee state is required.
                    </div>
                  )}
                </div>
                <div
                  className={
                    "form-group col-md-6 mb-4" +
                    (submitted && user_city ? " has-error" : "")
                  }
                >
                  <label htmlFor="user_city">Employee city*</label>
                  <select
                    className="form-control"
                    name="user_city"
                    onChange={(e) => {
                      setLocationId({
                        ...locationId,
                        city_id: fromJson(e.target.value).id,
                      });
                      handleRegion(e);
                    }}
                  >
                    {myCompany.company_city && (
                      <option>{myCompany.company_city}</option>
                    )}
                    {locationList.cityList &&
                      locationList.cityList.length > 0 &&
                      locationList.cityList.map((item, key) => {
                        return (
                          <option
                            key={key}
                            value={toJson({ name: item.name, id: item.id })}
                          >
                            {item.name}
                          </option>
                        );
                      })}
                  </select>
                  {submitted && !user_city && (
                    <div className="help-block">Employee city is required</div>
                  )}
                </div>
              </div>
            </MDBModalBody>
            <MDBModalFooter>
              <MDBBtn color="secondary" onClick={() => setOpen(false)}>
                Close
              </MDBBtn>
              <MDBBtn color="primary" type="submit">
                {creating === true ? (
                  <Beat loading={creating} />
                ) : (
                  "Create Employee"
                )}
              </MDBBtn>
            </MDBModalFooter>
          </form>
        </MDBModal>
      </MDBContainer>
    </div>
  );
}

export default CreateEmployee;
